'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = require('react-router');

var _scrollBehaviorLibUseStandardScroll = require('scroll-behavior/lib/useStandardScroll');

var _scrollBehaviorLibUseStandardScroll2 = _interopRequireDefault(_scrollBehaviorLibUseStandardScroll);

var _createRoutes = require('create-routes');

var _createRoutes2 = _interopRequireDefault(_createRoutes);

var _app = require('app');

var _app2 = _interopRequireDefault(_app);

var scrollHistory = (0, _scrollBehaviorLibUseStandardScroll2['default'])(function () {
  return _reactRouter.browserHistory;
})();

function loadConfig(cb) {
  var stuff = require('config');
  if (module.hot) {
    module.hot.accept(stuff.id, function () {
      return cb();
    });
  }
  return cb();
}

_reactRouter.browserHistory.listen(function (location) {
  if (_app2['default'].onRouteChange) {
    _app2['default'].onRouteChange(location);
  }
});

var routes = undefined;
loadConfig(function () {
  return _app2['default'].loadContext(function (pagesReq) {
    var _require = require('config');

    var pages = _require.pages;

    if (!routes) {
      routes = (0, _createRoutes2['default'])(pages, pagesReq);
    } else {
      (0, _createRoutes2['default'])(pages, pagesReq);
    }

    _reactDom2['default'].render(_react2['default'].createElement(_reactRouter.Router, {
      history: scrollHistory,
      routes: routes
    }), typeof window !== 'undefined' ? document.getElementById('react-mount') : void 0);
  });
});


// WEBPACK FOOTER //
// ../~/gatsby/dist/utils/web-entry.js